import { render, staticRenderFns } from "./PolivalenciaPage.vue?vue&type=template&id=057b2776"
import script from "./PolivalenciaPage.vue?vue&type=script&lang=js"
export * from "./PolivalenciaPage.vue?vue&type=script&lang=js"
import style0 from "./PolivalenciaPage.vue?vue&type=style&index=0&id=057b2776&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports